import { 
  Dialog, 
  DialogContent, 
  DialogDescription, 
  DialogHeader, 
  DialogTitle 
} from "@/components/ui/dialog";
import BrandAnalyzerForm from "@/components/BrandAnalyzerForm";

interface BrandAnalyzerDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

const BrandAnalyzerDialog = ({ open, onOpenChange }: BrandAnalyzerDialogProps) => {
  const handleSuccess = () => {
    // Close the dialog after successful submission
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent noScroll className="w-[calc(100vw-1rem)] sm:w-auto max-w-full sm:max-w-3xl lg:max-w-4xl bg-gradient-to-br from-primary/5 via-background to-primary/5 p-3 sm:p-4 md:p-6">
        <DialogHeader className="space-y-2 sm:space-y-3 mb-4 sm:mb-5 md:mb-6">
          <DialogTitle className="text-2xl sm:text-3xl md:text-4xl font-bold bg-gradient-to-r from-primary to-primary/60 bg-clip-text text-transparent">
            Request Your Report
          </DialogTitle>
          <DialogDescription className="hidden sm:block text-sm md:text-base">
            Get your free 360° AI Brand Report and discover how your brand appears online
          </DialogDescription>
        </DialogHeader>
        <BrandAnalyzerForm onSuccess={handleSuccess} />
      </DialogContent>
    </Dialog>
  );
};

export default BrandAnalyzerDialog;
